import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Reveal } from '@/components/generals/reveal'

interface SectionLabelProps {
    index?: string
    label: string
    className?: string
    tone?: 'dark' | 'light'
    /* The index is the accent by default. On the accent panel itself that
       renders invisible, so those call sites pass 'ink' or 'paper'. */
    accent?: 'brand' | 'ink' | 'paper'
}

const accents: Record<'brand' | 'ink' | 'paper', string> = {
    brand: 'text-brand',
    ink: 'text-ink',
    paper: 'text-paper'
}

/* The recurring eyebrow: an index in the accent colour followed by the
   section name, always sitting in the first grid column. */
export const SectionLabel: FC<SectionLabelProps> = ({
    index,
    label,
    className,
    tone = 'dark',
    accent = 'brand'
}): ReactNode => {
    return (
        <Reveal
            from='up'
            distance={18}
            className={cn('flex items-start gap-2', className)}
        >
            {index
                ? (
                    <span className={cn('t-mono', accents[accent])}>
                        {index}
                    </span>
                )
                : null}

            <span className={cn('t-mono', tone === 'dark' ? 'text-ink' : 'text-paper')}>
                {label}
            </span>
        </Reveal>
    )
}
